import image3 from'./Images/pexels-johnmark-smith-281962.jpg'


export  const ContactData =[
    {
        id:1,
        image:image3,
                },
    
]
